import React from 'react';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { Link } from 'react-router-dom'
import { NewsImg1, NewsImg2, NewsImg3, NewsImg4, ArrowRightIcon } from '../../Constant/Index';
const News = () => {

    const NewsData = [
        {
            Name: "Ocean Freight ",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            Img: NewsImg1
        },
        {
            Name: "Air Freight",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            Img: NewsImg2
        },
        {
            Name: "Warehousing",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            Img: NewsImg3
        },
        {
            Name: "Custom Brokerage",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            Img: NewsImg4
        },
        {
            Name: "Ocean Freight ",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            Img: NewsImg1
        },
        {
            Name: "Air Freight",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            Img: NewsImg2
        },
        {
            Name: "Warehousing",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            Img: NewsImg3
        },
        {
            Name: "Custom Brokerage",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            Img: NewsImg4
        },
        {
            Name: "Ocean Freight ",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            Img: NewsImg1
        },
        {
            Name: "Air Freight",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            Img: NewsImg2
        },
        {
            Name: "Warehousing",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            Img: NewsImg3
        },
        {
            Name: "Custom Brokerage",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            Img: NewsImg4
        },

    ];
    return (
        <>
            <Header />
            {/* News Section Start Here */}
            <section className="news-section news-page">
                <div className="container">
                    <div className="news-start-here">
                        {/* <div className="top-headings text-center  mx-auto">
                            <span className="small-heading">News</span>
                            <h3 className="md-heading">Let’s Checkout Our All Latest News</h3>
                            <p className='text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
                        </div> */}
                        <div className="top-heading text-center">
                            <h2 className="lg-heading secondary-text">Latest News</h2>
                        </div>
                        <div className="news-list">
                            <div className="row">
                                {
                                    NewsData.map((Single, index) => (
                                        <div className="col-lg-3 col-md-6 col-sm-6 mt-4 pt-2">
                                            <div className="single-news">
                                                <figure className='news-image'>
                                                    <img src={Single.Img} alt="" className="the-image w-100" />
                                                </figure>
                                                <div className="news-body">
                                                    <h5 className="xs-heading crop-1-lines">{Single.Name}</h5>
                                                    <p className='text crop-2-lines'>{Single.Para}</p>
                                                    <span className="date">March 8,2023</span>
                                                    <Link to="/news-details" className='news-link'><img src={ArrowRightIcon} alt="" /></Link>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }

                            </div>
                        </div>
                        <div className="web-paginations mt-5">

                            <nav aria-label="Page navigation ">
                                <ul className="pagination gap-3">
                                    <li className="page-item d-none">
                                        <a className="page-link" href="#" aria-label="Previous">
                                            <i className='fa fa-arrow-left'></i>
                                        </a>
                                    </li>
                                    <li className="page-item"><Link className="page-link active" href="#">1</Link></li>
                                    <li className="page-item"><Link className="page-link" href="#">2</Link></li>
                                    <li className="page-item"><Link className="page-link" href="#">3</Link></li>
                                    <li className="page-item"><Link className="page-link" href="#">4</Link></li>
                                    <li className="page-item"><Link className="page-link" href="#">5</Link></li>

                                    <li className="page-item">
                                        <a className="page-link next-arrow" href="#" aria-label="Next">
                                            <img src={ArrowRightIcon} alt="" />
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>
            {/* News Section End Here */}
            {/* Footer Included Here */}
            <Footer />
            {/* Footer Included Here */}
        </>
    )
}
export default News;